
import { IonApp, IonRouterOutlet } from '@ionic/vue';
export default {
  components: {IonApp, IonRouterOutlet}
}
